import { useState, useEffect } from 'react';

interface UseUserProfileProps {
  userId: string;
  type: 'user' | 'loveMatch';
}

const useUserProfile = ({ userId, type }: UseUserProfileProps) => {
  const TeamLinkle = 'WjiUT5ptxuU1SQ45OmC88GYHIYH3';

  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [followerCount, setFollowerCount] = useState(0);
  const [isFollowing, setIsFollowing] = useState(false);
  const [isTeamLinkle, setIsTeamLinkle] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [coin, setCoin] = useState<number | null>(0);
  const [disableChat, setDisableChat] = useState(false);
  const [disableCall, setDisableCall] = useState(false);

  const handleFollow = () => {
    const nextState = !isFollowing;
    setIsFollowing(nextState);
    setFollowerCount((prev) => (nextState ? prev + 1 : Math.max(0, prev - 1)));

    RoomUI.updateUserInfoFollow(nextState);
    FriendsDataManager.setFollowing(userId, nextState);
  };

  const handleMessage = () => {
    if (userInfo) {
      CommonUI.tryChat(userInfo.fbUid, userInfo.nick, userInfo.gender, userInfo.country, () => {});
    }
  };

  const handleCall = () => {
    if (userInfo) {
      CommonUI.makeCall(userInfo);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const checkCommPermit = (uid: string) => {
      if (MyDataManager.getPoliceVal() === 1) {
        FriendsDataManager.isAlba(uid, (isAlba: boolean) => {
          if (isAlba) {
            // Police 간에 chat, call을 허용하지 않는다.
            setDisableChat(true);
            setDisableCall(true);
          } else if (PrimeDataManager.getState() === 2) {
            // BJ는 chat을 허용하지 않는다.
            setDisableChat(true);
          }
        });
      }
    };

    const checkDisturb = (userInfo: UserInfo) => {
      if (PrimeDataManager.isBJ(userInfo.prime)) {
        PrimeDataManager.getDoNotDisturb(userInfo.fbUid, (err: any, isDisturb: boolean) => {
          if (!err && isDisturb) {
            setDisableCall(true);
          }
        });
      }
    };

    const getUserInfo = async () => {
      try {
        const fetchUserData = (targetUid: string) => new Promise<UserInfo>((resolve) => FriendsDataManager.getInfo(targetUid, (_: string, data: UserInfo) => resolve(data)));

        const fetchFollowerCount = (targetUid: string) => 
          new Promise<number>((resolve) => FriendsDataManager.getProfileDetail(targetUid, (userId: string, userInfo: any, arg: any) => resolve(userInfo.numFollowers ?? 0)));

        const fetchIsFollowing = (targetUid: string) => new Promise<boolean>((resolve) => FriendsDataManager.isFollowing(targetUid, (status: boolean) => resolve(status)));

        const [info, fCount, followingStatus] = await Promise.all([fetchUserData(userId), fetchFollowerCount(userId), fetchIsFollowing(userId)]);

        if (!isMounted) return;

        // 삭제된 유저
        if (FriendsDataManager.isDeleteUser(info)) {
          CommonUI.showSnackbar(`${brsc.no_user_info_2}`, { timeout: 2000 }, () => {});
        }

        // 권한 체크
        checkCommPermit(info.fbUid);
        // 방해금지 체크
        checkDisturb(info);

        setUserInfo(info);
        setFollowerCount(fCount);
        setIsFollowing(followingStatus);
        setIsTeamLinkle(info.fbUid === TeamLinkle);
        setIsAdmin(MyDataManager.getPoliceVal() === 2);

        // 코인 정보 조회
        const isBJUser = PrimeDataManager.isBJ(info.prime);
        const isBJMe = PrimeDataManager.isBJ(myinfo.prime);

        if (type === 'loveMatch' && isBJUser) {
          PrimeDataManager.getBJProfile(userId, (err: any, profile: any) => {
            if (!err && profile) setCoin(profile.cost);
          });
        } else if (isBJMe && !isBJUser) {
          CoinDataManager.getCoinInfo(userId, (uid: string, coinData: { current: number }) => {
            setCoin(coinData.current);
          });
        } else {
          setCoin(null);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getUserInfo();

    return () => {
      isMounted = false;
    };
  }, [userId, type]);

  return {
    userInfo,
    followerCount,
    isFollowing,
    isTeamLinkle,
    isAdmin,
    coin,
    disableChat,
    disableCall,
    handleFollow,
    handleMessage,
    handleCall,
  };
};

export default useUserProfile;
